import type { RowData } from './types';

export const HEADERS: RowData = {
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  birthDate: 'Birth Date',
  city: 'City',
  contractStatus: 'Contract status',
  contractType: 'Contract type',
  country: 'Country',
  currentCompensationChangeReason: 'Current Compensation Change Reason',
  currentCompensationHourlyRate: 'Current Compensation Hourly Rate',
  currentCompensationStartDate: 'Current Compensation Start Date',
  currentJobArea: 'Current Job Area',
  currentJobDirectLeader: 'Current Job Direct leader',
  currentJobDirectReports: 'Current Job Direct reports',
  currentJobPartner: 'Current Job Partner',
  currentJobSeniority: 'Current Job Seniority',
  currentJobStartDate: 'Current Job Start Date',
  currentJobTeam: 'Current Job Team',
  currentJobTitle: 'Current Job Title',
  currentEmergencyContactEmail: 'Emergency Contact Email',
  currentEmergencyContactName: 'Emergency Contact Name',
  emergencyContactPhone: 'Emergency Contact Phone',
  emergencyContactRelationship: 'Emergency Contact Relationship',
  ethnicity: 'Ethnicity',
  firstName: 'First Name',
  gender: 'Gender',
  githubLink: 'GitHub Link',
  hireDate: 'Hire Date',
  lastName: 'Last Name',
  linkedinUrl: 'LinkedIn Link',
  personalEmail: 'Personal Email',
  phone: 'Phone',
  state: 'State/Province',
  status: 'Status',
  trioProfileLink: 'Trio Profile Link',
  workEmail: 'Work Email',
  zipCode: 'Zip Code',
};

export const FIELDS: Array<keyof RowData> = [
  'firstName',
  'lastName',
  'workEmail',
  'phone',
  'personalEmail',
  'birthDate',
  'ethnicity',
  'gender',
  'addressLine1',
  'addressLine2',
  'state',
  'city',
  'country',
  'zipCode',
  'githubLink',
  'linkedinUrl',
  'trioProfileLink',
  'contractStatus',
  'contractType',
  'hireDate',
  'status',
  'currentCompensationStartDate',
  'currentCompensationHourlyRate',
  'currentCompensationChangeReason',
  'currentJobSeniority',
  'currentJobTitle',
  'currentJobStartDate',
  'currentJobArea',
  'currentJobTeam',
  'currentJobPartner',
  'currentJobDirectLeader',
  'currentJobDirectReports',
  'currentEmergencyContactEmail',
  'currentEmergencyContactName',
  'emergencyContactPhone',
  'emergencyContactRelationship',
];
